<div  class="mdl-grid mdl-grid--no-spacing"
      ng-if="$root.permisos.LLICENCIA.read">
  <h5 class="mdl-layout-title mdl-cell--12-col">
    {{'DEFAULT_PRODUCTES' | translate}}
  </h5>
  <div class="mdl-cell--12-col">
    <md-card>
      <md-card-content>
       

        <form>
        <div>
          <itec-error-block errors="ctrl.errors"></itec-error-block>
        </div>
        <table class="itec-table">
            <thead>
              <tr>
                <th>{{'SUBSCRIPCIO' | translate}}</th>
                <th>{{'DEFAULT_DATA_CADUCITAT' | translate}}</th>
                <th>{{'DEFAULT_NUMERO' | translate}}</th>
                <th ng-if="!ctrl.isAgrupat">{{'DEFAULT_TIPUS' | translate}}</th>
                <th>{{'PRODUCTES_INCLOSOS' | translate}}</th>
                <th ng-if="!ctrl.isAgrupat" ng-show="$root.permisos.ACTUALITZARLLICENCIA.edit">{{'DEFAULT_ACCIONS' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="llicencia in ctrl.llicencies.items">
                <td>{{llicencia.productenom}} </td>
                <td >
                  <itec-datepicker

                                    ng-model="llicencia.caducitat"
                                    ng-disabled="!angular.isUndefined(llicencia.editant) && !llicencia.editant "
                                    ng-showparam="field.show">
                  </itec-datepicker>
                </td>
                <td>
                     {{llicencia.numero}}
                </td>
                <td ng-if="!ctrl.isAgrupat">
                  <span ng-if="llicencia.botiga">{{'botiga' | translate}}</span> 
                  <span ng-if="llicencia.botiga && llicencia.demo"> - </span> 
                  <span ng-if="llicencia.demo">{{'demo' | translate}} </span>
                  <span ng-if="(llicencia.demo && llicencia.renovacio) || (llicencia.botiga && !llicencia.demo && llicencia.renovacio)"> - </span> 
                  <span ng-if="llicencia.renovacio">{{'renovacio' | translate}} </span>
                </td>
                <td >
                      <div ng-repeat="produac in llicencia.listllicproductes">
                          {{produac.productenom}}
                      </div>
                </td>
                <td ng-if="!ctrl.isAgrupat">
                 <button ng-if="!ctrl.isAgrupat"
                    ng-show="llicencia.editant "
                    title="{{'DEFAULT_ACCIONS_EDITAR' | translate}}"
                    aria-label="{{'DEFAULT_ACCIONS_EDITAR' | translate}}"
                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
                    ng-click="ctrl.saveNewDate(llicencia)">
                      <i class="material-icons">save</i>
                  </button>

                  <button 
                    ng-if="!ctrl.isAgrupat && !angular.isUndefined(llicencia.editant) && !llicencia.editant && $root.permisos.LLICENCIA.edit"
                    title="{{'DEFAULT_ACCIONS_EDITAR' | translate}}"
                    aria-label="{{'DEFAULT_ACCIONS_EDITAR' | translate}}"
                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
                    ng-click="llicencia.editant = true">
                      <i class="material-icons">edit</i>
                  </button>

                  <button 
                    ng-if="!ctrl.isAgrupat && $root.permisos.ESBORRARLLICENCIA.delete"
                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
                    itec-dialog-confirm
                    title="{{'DEFAULT_ACCIONS_ESBORRAR' | translate}}"
                    aria-label="{{'DEFAULT_ACCIONS_ESBORRAR' | translate}}"
                    itec-dialog-confirm-title="{{'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR' | translate}}"
                    itec-dialog-confirm-text-content="{{'PRODUCTE_DELETE_CONTENT' | translate}}"
                    itec-dialog-confirm-text-ok="DIALOG_CONFIRM"
                    itec-dialog-confirm-text-cancel="DIALOG_CANCEL"
                    itec-dialog-confirm-function-ok="ctrl.deleteFunction(llicencia)">
                      <i class="material-icons">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

        <div class="visualClear">&nbsp;</div>

        <itec-button ng-click="ctrl.add()"
          label="AFEGIR_PRODUCTE"
           ng-if="$root.permisos.AFEGIRLLICENCIA.add">
        </itec-button>

      </md-card-content>
    </md-card>
  </div>

</div>
